import PipelineStateIcon from "app/components/shared/PipelineStateIcon";
import { StepProps } from "./Step";
import { WaitJob } from "./types/WaitJob";

export default function WaiterStep({ job, stepClassName }: StepProps<WaitJob>) {
  if (job.continueOnFailure) {
    return (
      <div
        key={job.id}
        className={`${stepClassName} dark-gray relative`}
        title="Wait for all previous steps to finish including failures"
      >
        <i
          className="fa fa-times absolute"
          style={{ fontSize: 12, top: 3, right: 3 }}
        />
        <PipelineStateIcon job={job} />
      </div>
    );
  }

  return (
    <div
      key={job.id}
      className={`${stepClassName} dark-gray`}
      title="Wait for all previous steps to pass"
    >
      <PipelineStateIcon job={job} />
    </div>
  );
}
